// src/pages/PortfolioSingle.js
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { portfolioItems } from '../data/portfolioData';
import SEO from '../components/SEO';

const PortfolioSingle = () => {
  const { slug } = useParams();
  const project = portfolioItems.find(item => item.slug === slug);

  if (!project) {
    return <div className="container mt-5 pt-5"><h2>Project not found</h2></div>;
  }

  return (
     <>
      <SEO 
        title={`${project.title} | Franklin's Portfolio`}
        description={project.description}
        image={project.image}
        type="website"
      />
    <main>
      <section className="content">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-12 col-lg-5">
              <div className="heading">
                <div className="portfolio-meta d-flex align-items-center">
                  <div className="portfolio-terms">
                    {project.role.map((role, index) => (
                      <Link key={index} className="terms" to="/works">{role}</Link>
                    ))}
                  </div>
                  <span className="date">{project.year}</span>
                </div>
                <h2>{project.title}</h2>
                <p>{project.description}</p>
              </div>
            </div>
            <div className="col-12 col-lg-6 items portfolio-meta mt-3 mt-md-0">
              <div className="task">
                <h6 className="title mb-3">Task</h6>
                <span className="details">{project.task}</span>
              </div>
              <div className="content item d-flex flex-column flex-md-row justify-content-between">
                <div className="role">
                  <h6 className="title mt-0 mb-1 mb-md-3">Role/Services</h6>
                  <div className="portfolio-terms">
                    {project.role.map((role, index) => (
                      <Link key={index} className="terms" to="/works">{role}</Link>
                    ))}
                  </div>
                </div>
                <div className="client my-3 my-md-0">
                  <h6 className="title mt-0 mb-1 mb-md-3">Client</h6>
                  <span>{project.client}</span>
                </div>
                <div className="category">
                  <h6 className="title mt-0 mb-1 mb-md-3">Category &amp; Year</h6>
                  <span>{project.category} ©{project.year}</span>
                </div>
              </div>
              <div className="socials item">
                <a className="nav-link d-inline-flex swap-icon ms-0" href="/">Live Site <i className="icon bi bi-arrow-right-short"></i></a>
              </div>
            </div>
          </div>
          <div className="row portfolio-content items">
            <div className="col-12">
              {project.images.map((image, index) => (
                <div key={index} className="item">
                  <img loading="lazy" alt={`Gallery ${index+1}`} src={image} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="cta border-top border-light-subtle">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-12 col-md-10 col-lg-7">
              <h2 className="title mb-0 mb-md-2">Let's Create Something</h2>
              <div className="cta-text">
                <span className="line-item h2">Together</span>
                <span className="line"></span>
                <a href="mailto:fernandez954@gmail.com" className="btn btn-dark">Get In Touch!<i className="icon bi bi-arrow-right ms-1"></i>
                  <span></span>
                </a>
              </div>
              <div className="socials mt-5">
                <nav className="nav justify-content-center">
                  <a className="nav-link swap-icon" href="/#">Instagram
                    <i className="icon rotate bi bi-arrow-right-short"></i>
                  </a>
                  <a className="nav-link swap-icon" href="/#">Twitter
                    <i className="icon rotate bi bi-arrow-right-short"></i>
                  </a>
                  <a className="nav-link swap-icon" href="/#">LinkedIn
                    <i className="icon rotate bi bi-arrow-right-short"></i>
                  </a>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
}

export default PortfolioSingle;